import React from 'react'

import { useTheme } from '@thg-commerce/enterprise-theme'

import { generateSlides, Slides, StripBannerQueryResult } from './Slides/Slides'

export interface StripBannerCustomisableProps {
  stripBannerTitleOne?: string
  stripBannerContentOne?: string
  stripBannerURLOne?: string
  stripBannerTitleTwo?: string
  stripBannerContentTwo?: string
  stripBannerURLTwo?: string
  stripBannerTitleThree?: string
  stripBannerContentThree?: string
  stripBannerURLThree?: string
  stripBannerTitleFour?: string
  stripBannerContentFour?: string
  stripBannerURLFour?: string
  enableRotatingBanner?: boolean
  hideDefaultBanner?: string
  stripBannerPositionOne?: number
  stripBannerPositionTwo?: number
  stripBannerPositionThree?: number
  stripBannerPositionFour?: number
  stripBannerCTATextOne?: string
  stripBannerCTATextTwo?: string
  stripBannerCTATextThree?: string
  stripBannerCTATextFour?: string
  widgetData?: StripBannerQueryResult | undefined
}

export const StripBannerCustomisable = (
  props: StripBannerCustomisableProps,
) => {
  const theme = useTheme()

  const slides = React.useMemo(() => {
    return generateSlides(props.widgetData, theme)
  }, [props.widgetData, theme])

  if (props.hideDefaultBanner) {
    return null
  }

  return (
    <div>
      <Slides slides={slides} rawPanelInformation={props.widgetData} />
    </div>
  )
}
